import { all, put, call, takeEvery, select } from "redux-saga/effects";
import {
    UPDATE_MODULE_DATA, UPDATE_MODULE_DATA_SUCCESS, MODULE_LIST, MODULE_LIST_SUCCESS, MODULE_EDIT_METADATA_SUCCESS, MODULE_EDIT_METAINFO, MODULE_PAGE_PREVIEW, MODULE_PAGE_PREVIEW_SUCCESS,
    SAVE_MODULE, SAVE_MODULE_SUCCESS, SAVE_MODULE_QUESTIONS, FETCH_SURVEY_RESPONSE, FETCH_SURVEY_RESPONSE_SUCCESS, DELETE_MODULE_SUCCESS, DELETE_MODULE, SHOW__HIDE_LOADER, /* SAVE_MODULE_QUESTIONS_SUCCESS */
    GET_QUESTION_VERSIONS,
    GET_QUESTION_VERSIONS_SUCCESS,

    USER_ASSIGNED_COUNTRY_LIST,
    USER_ASSIGNED_COUNTRY_LIST_SUCCESS,
    UNMOUNT_PREVIEW_RESPONSE_SUCCESS,
    UNMOUNT_PREVIEW_RESPONSE,
    UNMOUNT_MODULE_LIST_RESPONSE_SUCCESS,
    UNMOUNT_MODULE_LIST_RESPONSE,
    UNMOUNT_USER_ASSIGNED_COUNTRY_LIST_SUCCESS,
    MODULE_LIST_BY_SURVEY,
    FETCH_SURVEY_RESPONSE_OFFLINE,
    FETCH_SURVEY_RESPONSE_OFFLINE_SUCCESS,
    SYNC_SURVEY_RESPONSE_OFFLINE,
    SYNC_SURVEY_RESPONSE_OFFLINE_SUCCESS,
    SET_OFFLINE_MODE,
    SET_OFFLINE_MODE_SUCCESS,
    SYNC_SURVEY_RESPONSE_OFFLINE_COMPLETED,
    SYNC_SURVEY_RESPONSE_OFFLINE_COMPLETED_SUCCESS,
    DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY,
    SYNC_SURVEY_GET_USER_COUNTRIES_KEY,
    SAVE_MODULE_RESPONSE,
    APPROVE_QUESTION
} from '../constants/constants';
import {
    getModuleListCall, getEditModuleMetadataCall, saveModuleCall, updateModuleCall, getModulePreviewCall,
    saveModuleQuestionsCall,
    getSurveyResponseCall,
    deleteModuleCall,
    getCountriesAssignedToUserCall,
    getQuestionsWithAllVersionCall,
    getModuleListBySurveyCall,
    getSurveyResponseOfflineCall,
    syncOfflineResponseCall,
    saveResponseCall,
    approveQuestionCall
} from '../effects/api/api.module';

import { updateModule } from '../constants/commonFunctions';
import { getLocalStorageValue, setLocalStorageValue } from 'src/effects/utils/local-storage';


function* getModuleList() {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(getModuleListCall);

        yield put({ payload: response, type: MODULE_LIST_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {

        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* getModuleListBySurveyId(moduleId: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(getModuleListBySurveyCall, moduleId);
        console.log('getModuleListBySurveyId', response)
        yield put({ payload: response, type: MODULE_LIST_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {

        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}


function* getEditModuleMetadata(moduleId: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(getEditModuleMetadataCall, moduleId);
        yield put({ payload: response, type: MODULE_EDIT_METADATA_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* getModulePreview(data: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(getModulePreviewCall, data);
        yield put({ payload: { response }, type: MODULE_PAGE_PREVIEW_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* saveModule() {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const stateData = yield select(modelData);
        let response;

        if (!stateData.editModuleMetadata.module.id) {
            response = yield call(saveModuleCall, stateData.editModuleMetadata.module);
        }
        else {
            response = yield call(updateModuleCall, stateData.editModuleMetadata.module);
        }

        yield put({ payload: response, type: SAVE_MODULE_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* saveModuleQuestions() {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const stateData = yield select(modelData);
        let response;
        const moduleId = stateData.editModuleMetadata.module.id;
        const data = { moduleQuestion: stateData.editModuleMetadata.moduleQuestion, id: moduleId };

        response = yield call(saveModuleQuestionsCall, data);
        yield put({ payload: response, type: SAVE_MODULE_SUCCESS }); // SAVE_MODULE_QUESTIONS_SUCCESS

        if (response.data.success) {
            const responseEditMetaData = yield call(getEditModuleMetadataCall, { payload: moduleId });
            yield put({ payload: responseEditMetaData, type: MODULE_EDIT_METADATA_SUCCESS });
        }

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* updateModuleData(data: any) {

    yield put({ type: SHOW__HIDE_LOADER, payload: true });

    const stateData = yield select(modelData);
    const updatedStateData = updateModule(data, stateData);
    yield put({ payload: updatedStateData, type: UPDATE_MODULE_DATA_SUCCESS });

    yield put({ type: SHOW__HIDE_LOADER, payload: false });


}


function* getSurveyResponse(data: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(getSurveyResponseCall, data);
        yield put({ payload: null, type: UNMOUNT_PREVIEW_RESPONSE_SUCCESS });

        yield put({ payload: { response }, type: FETCH_SURVEY_RESPONSE_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* deleteModule(data: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(deleteModuleCall, data);
        yield put({ payload: response, type: DELETE_MODULE_SUCCESS });

        const updateGrid = yield call(getModuleListCall);
        yield put({ payload: updateGrid, type: MODULE_LIST_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}


function* getQuestionsWithAllVersion(data: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(getQuestionsWithAllVersionCall, data.payload.moduleId, data.payload.questionId);

        yield put({ payload: { response }, type: GET_QUESTION_VERSIONS_SUCCESS });
       
        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* getCountriesAssignedToUser() {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        let response = null;
        const userId = getLocalStorageValue('user').id;
        const isOfflineMode = getLocalStorageValue(`UserId_${userId}_${DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY}`);

        if (isOfflineMode) {
            response = yield getLocalStorageValue(`UserId_${userId}_${SYNC_SURVEY_GET_USER_COUNTRIES_KEY}`);
            if (response === null) {
                response = yield call(getCountriesAssignedToUserCall);
                yield setLocalStorageValue(`UserId_${userId}_${SYNC_SURVEY_GET_USER_COUNTRIES_KEY}`, JSON.stringify(response));
            }
        }
        else {
            response = yield call(getCountriesAssignedToUserCall);
            yield setLocalStorageValue(`UserId_${userId}_${SYNC_SURVEY_GET_USER_COUNTRIES_KEY}`, JSON.stringify(response));
        }

        yield put({ payload: { response }, type: USER_ASSIGNED_COUNTRY_LIST_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* unmountPreviewResponse(data: any) {

    yield put({ type: SHOW__HIDE_LOADER, payload: true });

    yield put({ payload: null, type: UNMOUNT_USER_ASSIGNED_COUNTRY_LIST_SUCCESS });

    yield put({ payload: data, type: UNMOUNT_PREVIEW_RESPONSE_SUCCESS });

    yield put({ type: SHOW__HIDE_LOADER, payload: false });
}

function* unmountModuleListResponse(data: any) {

    yield put({ type: SHOW__HIDE_LOADER, payload: true });

    yield put({ payload: data, type: UNMOUNT_MODULE_LIST_RESPONSE_SUCCESS });

    yield put({ type: SHOW__HIDE_LOADER, payload: false });
}


function* getSurveyResponseOffline(data: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(getSurveyResponseOfflineCall, data);
        yield put({ payload: null, type: UNMOUNT_PREVIEW_RESPONSE_SUCCESS });

        yield put({ payload: { response }, type: FETCH_SURVEY_RESPONSE_OFFLINE_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* saveModuleResponse(questionData: any) {
    yield put({ type: SHOW__HIDE_LOADER, payload: true });
    yield saveResponseCall(questionData);
    yield put({ type: SHOW__HIDE_LOADER, payload: false });
}


function* syncOfflineResponse(data: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(syncOfflineResponseCall, data);

        yield put({ payload: { response }, type: SYNC_SURVEY_RESPONSE_OFFLINE_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ payload: { response: { payload: { data: true } } }, type: SYNC_SURVEY_RESPONSE_OFFLINE_SUCCESS });
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* setSurveyOfflineMode(data: any) {
    try {

        // yield put({ type: SHOW__HIDE_LOADER, payload: true });

        yield put({ payload: { data }, type: SET_OFFLINE_MODE_SUCCESS });

        // yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        // yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}


function* surveyOfflineCompleted() {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        yield put({ payload: null, type: SYNC_SURVEY_RESPONSE_OFFLINE_COMPLETED_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* approveQuestion(questionData: any) {
    try {
        yield put({ type: SHOW__HIDE_LOADER, payload: true });
        const responseApprove = yield call(approveQuestionCall, questionData, questionData.adminQuestionStatus);
        if (responseApprove.data.success) {
            const response = yield call(getModulePreviewCall, questionData);
            yield put({ payload: { response }, type: MODULE_PAGE_PREVIEW_SUCCESS });
        }
        
        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}


export const modelData = (state: any) => state.model
export default function* ModuleSaga() {
    yield all([
        takeEvery(MODULE_LIST, getModuleList),
        takeEvery(MODULE_LIST_BY_SURVEY, getModuleListBySurveyId),
        takeEvery(MODULE_EDIT_METAINFO, getEditModuleMetadata),
        takeEvery(UPDATE_MODULE_DATA, updateModuleData),
        takeEvery(SAVE_MODULE, saveModule),
        takeEvery(SAVE_MODULE_QUESTIONS, saveModuleQuestions),
        takeEvery(MODULE_PAGE_PREVIEW, getModulePreview),
        takeEvery(FETCH_SURVEY_RESPONSE, getSurveyResponse),
        takeEvery(DELETE_MODULE, deleteModule),
        takeEvery(USER_ASSIGNED_COUNTRY_LIST, getCountriesAssignedToUser),
        takeEvery(GET_QUESTION_VERSIONS, getQuestionsWithAllVersion),
        takeEvery(UNMOUNT_PREVIEW_RESPONSE, unmountPreviewResponse),
        takeEvery(UNMOUNT_MODULE_LIST_RESPONSE, unmountModuleListResponse),
        takeEvery(FETCH_SURVEY_RESPONSE_OFFLINE, getSurveyResponseOffline),
        takeEvery(SYNC_SURVEY_RESPONSE_OFFLINE, syncOfflineResponse),
        takeEvery(SET_OFFLINE_MODE, setSurveyOfflineMode),
        takeEvery(SYNC_SURVEY_RESPONSE_OFFLINE_COMPLETED, surveyOfflineCompleted),
        takeEvery(SAVE_MODULE_RESPONSE, saveModuleResponse),
        takeEvery(APPROVE_QUESTION, approveQuestion)
    ])
}


// WEBPACK FOOTER //
// ./src/saga/saga.module.tsx